import React from 'react';
import { Page, Text, View, Document, StyleSheet,Image } from '@react-pdf/renderer';
//import AGMLogo from "../../assets/images/logoagm.png";
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#ffffff'
  },
  section: {
    margin: 10,
    padding: 10,
    paddingLeft:10,
    flexGrow: 1,
    fontSize: 10,
    border:1
  },
  section2: {
    margin: 10,
    padding: 200,
    paddingLeft:10,
    flexGrow: 1,
    fontSize: 12,
    alignItems: "center"
  },
  baseText: {
    fontWeight: 'bold'
  },
  innerText: {
    color: 'black',
    fontWeight: 'bold'
  }

});

// Create Document Component
const MyDocument = (item) => {
  const [ListaItem, setLista] = React.useState([]);

  const [Costosum, setCostosum] = React.useState([]);
  const [Utilidad, setUtilidad] = React.useState([]);
  const [Iva, setIva] = React.useState([]);
  const [Total, setTotal] = React.useState([]);
  const [Tercero, setTercero] = React.useState([]);
  const [Alcance, setAlcance] = React.useState('');
  const [Hoy, setHoy] = React.useState('');
  const [Proyecto, setProyecto] = React.useState('');

  React.useEffect(() => {
    VerRegistros(item.ite.ID_COTIZACION); 
    //console.log(item.ite);
    //setUtilidad(item.ite.COSTO_ADMIN_OBRA);

 },[item]);

 const VerRegistros =  (id) => {
  

  authAxios.get("cotizaciones/ver_item/"+id)
      .then((datosRespuesta) => {
          //console.log(datosRespuesta.data);
          var status = datosRespuesta.data.status;
          if (status) {
              Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
              window.localStorage.clear();
              window.location.href = '/';
          }
          //console.log(datosRespuesta.data.items);
          const item = datosRespuesta.data.items;
          setLista(datosRespuesta.data.items);

          setCostosum(datosRespuesta.data.total);
          
          setIva(datosRespuesta.data.iva);
          setTotal(datosRespuesta.data.gran_total);
          setUtilidad(datosRespuesta.data.utilidad_neta);
          setTercero(datosRespuesta.data.terceros);
          setAlcance(datosRespuesta.data.alcance);
          setHoy(datosRespuesta.data.hoy);
          setProyecto(datosRespuesta.data.proyecto);

         // this.setState({ CargandoMat:1,ListaItem: datosRespuesta.data.items, TotalIva: datosRespuesta.data.iva,TotalCot:datosRespuesta.data.total,GranTotal:datosRespuesta.data.gran_total});
          Swal.close();
          
      })
      .catch(console.log);
      

};

  return (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section} >
        <Text style={{textAlign: "center" }} >AGM DESARROLLOS</Text>
        {/* <Image src={AGMLogo} alt="" style={{ width: 100, height: 70,textAlign: "center" }} /> */}
       
        <Text style={{textAlign: "center" }} >FORMATO DE COTIZACIÓN UCAPS</Text>
        <Text style={{textAlign: "center" ,backgroundColor: '#A9D0F5',size:14}}  >NÚMERO DE COTIZACIÓN : COT-<Text style={{ color: '#6E6E6E' }}> {item.ite.NO_COTIZACION} v {item.ite.VERSION}  </Text></Text>
        <Text>___________________________________________________________________________________________________</Text>
        <View style={{flexDirection:'row',border:1}}>
             <View style={{width:100}}>
               <Text>
               MINICIPIO:
               </Text>
            </View>
            <View style={{width:350}}>
               <Text>
               {Tercero.DEPARTAMENTO} -  {Tercero.MUNICIPIO}
               </Text>
            </View>
        </View>
        <View style={{flexDirection:'row',border:1}}>
             <View style={{width:100}}>
               <Text style={{ color: '#6E6E6E' }}>
               PROYECTO
               </Text>
            </View>
            <View style={{width:350}}>
               <Text style={{ color: '#6E6E6E' }}>
                {Proyecto}
               </Text>
            </View>
        </View>
        <View style={{flexDirection:'row',border:1}}>
             <View style={{width:100}}>
               <Text style={{ color: '#6E6E6E' }}>
               FECHA
               </Text>
            </View>
            <View style={{width:350}}>
               <Text style={{ color: '#6E6E6E' }}>
               {Hoy}
               </Text>
            </View>
        </View>
       
        <View style={{flexDirection:'row',border:1}}>
             <View style={{width:100}}>
               <Text>
               DURACION:
               </Text>
            </View>
            <View style={{width:350}}>
               <Text>
               {item.ite.FECHA_INICIO} AL {item.ite.FECHA_FINAL}
               </Text>
            </View>
        </View>
        <View style={{flexDirection:'row',border:1}}>
             <View style={{width:100}}>
               <Text style={{ color: '#6E6E6E' }}>
                  ALCANCE
               </Text>
            </View>
            <View style={{width:350}}>
               <Text style={{ color: '#6E6E6E' }}>
                 {Alcance}
               </Text>
            </View>
        </View>

        <Text>__________________________________________________________________________________________________</Text>
       
        <Text style={{textAlign: "center" ,backgroundColor: '#A9D0F5'}} > {Alcance} </Text>
          
       
        <Text> </Text>

        <View style={{flexDirection:'row',backgroundColor: '#A9D0F5',border:1}}>
            <View style={{width:50}}>
               <Text >
                  ITEM
               </Text>
            </View>
            <View style={{width:250}}>
               <Text >
                  DESCRIPCION
               </Text>
            </View>
            
            <View style={{width:50}}>
               <Text >
                  CANT
               </Text>
            </View>
            <View style={{width:100}}>
               <Text >
                  VALOR UND
               </Text>
            </View>
            <View style={{width:50}}>
               <Text >
                  IVA
               </Text>
            </View>
            <View style={{width:100}}>
               <Text >
                  VALOR TOTAL
               </Text>
            </View>
        </View>
        
        {ListaItem.map((fila,i) => (
        
            <View key={fila.ID_DETALLE} style={{flexDirection:'row',border:1}}  >
                <View style={{width:50,fontSize: 7}}>
                  <Text>
                      {fila.CODIGO}
                  </Text>
                </View>
                <View style={{width:250,fontSize: 7}}>
                  <Text>
                  {fila.NOMBRE}
                  </Text>
                </View>
                <View style={{width:50,textAlign: "center",fontSize: 7}}>
                  <Text>
                  {currencyFormat(fila.CANTIDAD)}
                  </Text>
                </View>
                <View style={{width:50,textAlign: "right",fontSize: 7 }}>
                  <Text>
                  {currencyFormat(fila.VALOR_UNIDAD)}
                  </Text>
                </View>
                <View style={{width:100,textAlign: "right",fontSize: 7}}>
                  <Text>
                  {currencyFormat((fila.IVA_ADMIN)*fila.CANTIDAD)}
                  </Text>
                </View>
                <View style={{width:100,textAlign: "right",fontSize: 7}}>
                  <Text>
                  {currencyFormat(fila.TOTAL)} 
                  </Text>
                </View>
        </View>
    
       ))
       }
 
 
          <Text style={{textAlign: "center" ,backgroundColor: '#A9D0F5'}} >TOTALES</Text>
          <View style={{flexDirection:'row'}}>
            <View style={{textAlign: "right" ,width:500}}>
               <Text >
               TOTAL SUMINISTRO
               </Text>
            </View>
            <View style={{width:100}}>
                <Text style={{textAlign: "right" }}>
                   $ {currencyFormat(Costosum)}
                </Text>
            </View>
          </View>
          <View style={{flexDirection:'row'}}>
            <View style={{textAlign: "right" ,width:500}}>
               <Text >
               COSTO Administrativo
               </Text>
            </View>
            <View style={{width:100}}>
                <Text style={{ textAlign: "right"}}>
                   $ {currencyFormat(Utilidad)}
                </Text>
            </View>
          </View>
          {/* <View style={{flexDirection:'row'}}>
           {/*  <View style={{textAlign: "right" ,width:500}}>
               <Text >
               IVA
               </Text>
            </View> 
            <View style={{width:100}}>
                <Text style={{ textAlign: "right" }}>
                   $ {currencyFormat(Iva)}
                </Text>
            </View>
          </View> */}
          <View style={{flexDirection:'row'}}>
            <View style={{textAlign: "right" ,width:500}}>
               <Text >
               TOTAL OBRA
               </Text>
            </View>
            <View style={{width:100}}>
                <Text style={{ textAlign: "right" }}>
                   $ {currencyFormat(Total)}
                </Text>
            </View>
          </View>
          <Text>{'\n'}______________________________________________________________________________________________________{'\n'}{'\n'}</Text>
          <View style={{flexDirection:'row'}}>
            <View style={{width:500}}>
               <Text>
               {'\n'}{'\n'}Agradecemos su amable invitación a cotizar y quedamos atentos a resolver cualquier inquietud al respecto.{'\n'}{'\n'}
               </Text>
            </View>

          </View>
          <View style={{flexDirection:'row'}}>
            
           

            <View style={{width:280}}>
               <Text>
                   {'\n'}Cordialmente.{'\n'}{'\n'}
               
               </Text>
               <Text style={{ color: '#E6E6E6',textAlign: "" }}>
                    {'\n'}{'\n'}FIRMA Y SELLO DE LA EMPRESA
                </Text>
            </View>
            
            
          </View>
    
          {'\n'}
          <Text>______________________________________________________________________________________________________{'\n'}{'\n'}</Text>
          <Text style={{textAlign: "center"}}>{'\n'}{'\n'}AGM DESARROLLO {'\n'}
              
                 TEL. 3045049860 - 3046690903{'\n'}
		            CARTAGENA - BARRANQUILLA</Text>
       
          
      </View>
     
      
     
      
    </Page>
  </Document>
  )
  }
export default MyDocument;